import { alpha, useTheme } from '@mui/material';
import { grey } from '@mui/material/colors';
const useSearchInputStyles = () => {
    const theme = useTheme();
    const isLightMode = theme.palette.mode === 'light';
    return {
        SearchField: {
            padding: '6px 12px',
            background: alpha(grey[500], 0.32),
            borderRadius: '12px',
            input: {
                padding: '0',
                outline: 'none',
                color: isLightMode ? theme.palette.common.white : theme.palette.grey[900],
                ...theme.typography.body1,
                '&::placeholder': {
                    color: isLightMode ? 'white' : theme.palette.grey[900]
                }
            }
        }
    };
};
export default useSearchInputStyles;
